export class Contain {
    get id() {
        return this.containState.id;
    }
    get moduleId() {
        return this.containState.moduleId;
    }
    get name() {
        return this.containState.name;
    }
    set name(name) {
        this.containState.name = name;
    }
    set moduleName(moduleName) {
        this.containState.moduleName = moduleName;
    }
    constructor(containState) {
        this.containState = containState;
    }
    getState() {
        return this.containState;
    }
}
